class CardComplain {
  constructor() {

    if(document.querySelector('.card--public-complain') != null && document.querySelector('.card--public-complain') != undefined) {
      this.setEventsUser();
    }

  }
  
  setEventsUser() {     
      var status = document.querySelectorAll('.card__status');

      if(status != null && status != undefined) {

        status.forEach(s => {
          var public_btn = s.querySelector('.public-btn');

          if(public_btn != null && public_btn != undefined) {
            public_btn.addEventListener('click', function(e) {
              e.preventDefault();
              s.classList.remove('public');
              s.classList.add('private');    
            });
          }

          var private_btn = s.querySelector('.private-btn');

          if(private_btn != null && private_btn != undefined) {
            private_btn.addEventListener('click', function(e) {
              e.preventDefault();
              s.classList.add('changing');
            });
          }

          var public_ok_btn = s.querySelector('.btn-ok');

          if(public_ok_btn != null && public_ok_btn != undefined) {
            public_ok_btn.addEventListener('click', function(e) {
              e.preventDefault();
              s.classList.remove('changing');
              s.classList.remove('private');
              s.classList.add('public');   
            });
          }

          var public_cancel_btn = s.querySelector('.btn-cancel');

          if(public_cancel_btn != null && public_cancel_btn != undefined) {
            public_cancel_btn.addEventListener('click', function(e) {
              e.preventDefault();
              s.classList.remove('changing');
            });
          }
        });
      }

  }


    
}

$(document).ready(function() {
  const cardComplain = new CardComplain();
});
